module.exports = __webpack_public_path__ + "media/fonts/glyphicons-halflings-regular-ff423a42.svg";